import { API_BASE_URL, apiGet } from '@/api/http';

export const getIndustries = () =>
  apiGet<{ id: string; name: string }[]>(`${API_BASE_URL}industries/`);
